import { Box, Card, Icon, Paragraph } from '@zillow/constellation-10';
import { IconCircleFilled } from '@zillow/constellation-icons';
import { useWebSocketContext } from '@zg-rentals/web-socket-react';
import { isSatelliteWebSocketEvent } from '@zg-rentals/satellite-web-socket-helpers';
import { WEBSOCKET_DEBUG } from '../../hooks/useWebsocketFeature';

export default function WebSocketStatus() {
  const { isConnecting, isWebSocketEnabledAndReady, lastMessage, authenticatedUserToken } = useWebSocketContext();

  if (!WEBSOCKET_DEBUG) return null;

  return (
    <Card
      css={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        zIndex: 'tooltip',
      }}
    >
      <Paragraph
        textStyle="body-sm-bold"
        css={{
          marginBottom: 'tightest',
        }}
      >
        WebSocket Status
      </Paragraph>

      <Box css={{ display: 'flex', alignItems: 'center', gap: 'tight', marginBottom: 'tightest' }}>
        <Icon
          size="sm"
          css={{ color: isWebSocketEnabledAndReady ? 'green.300' : isConnecting ? 'yellow.300' : 'red.300' }}
        >
          <IconCircleFilled />
        </Icon>
        <Paragraph textStyle="body-sm">
          {isWebSocketEnabledAndReady ? 'Ready' : isConnecting ? 'Connecting' : 'Disconnected'}
        </Paragraph>
      </Box>

      {authenticatedUserToken ? (
        <Paragraph textStyle="body-sm" css={{ wordBreak: 'break-all', marginBottom: 'tightest' }}>
          <strong>Auth: </strong>
          {authenticatedUserToken}
        </Paragraph>
      ) : (
        <Paragraph textStyle="body-sm">Not authenticated</Paragraph>
      )}

      {lastMessage && (
        <Box css={{ marginBottom: 'tightest' }}>
          <Paragraph textStyle="body-sm" css={{ marginBottom: 'tightest' }}>
            <strong>Last Event:</strong> {lastMessage.event?.type || 'unknown'}
          </Paragraph>
          {isSatelliteWebSocketEvent(lastMessage.event) && lastMessage.event.conversationId && (
            <Paragraph textStyle="body-sm" css={{ marginBottom: 'tightest', wordBreak: 'break-all' }}>
              <strong>Conversation:</strong> {lastMessage.event.conversationId}
            </Paragraph>
          )}
          {lastMessage.topic && (
            <Paragraph textStyle="body-sm" css={{ marginBottom: 'tightest', wordBreak: 'break-all' }}>
              <strong>Topic:</strong> {lastMessage.topic}
            </Paragraph>
          )}
          {lastMessage.ts && (
            <Paragraph textStyle="body-sm" css={{ wordBreak: 'break-all' }}>
              <strong>Timestamp:</strong> {new Date(lastMessage.ts).toLocaleTimeString()}
            </Paragraph>
          )}
        </Box>
      )}
    </Card>
  );
}
